module.exports = __webpack_public_path__ + "static/media/login-cartao.434c9bf7.jpg";